import { AudioManager } from "../../AudioManager";
import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { GameVars } from "../../GameVars";
import { Button } from "../../utils/Utils";

export class GameOverLayer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        if (GameVars.score > GameVars.gameData.highScore) {
            GameVars.gameData.highScore = GameVars.score;
            GameManager.writeGameData();
        }

        const darkLayer = new Phaser.GameObjects.Graphics(this.scene);
        darkLayer.fillStyle(0x1e2238, .85);
        darkLayer.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        this.add(darkLayer);

        const scaledItemsContainer = new Phaser.GameObjects.Container(this.scene);
        scaledItemsContainer.x = GameConstants.GAME_WIDTH / 2;
        scaledItemsContainer.y = GameConstants.GAME_HEIGHT / 2;
        scaledItemsContainer.scaleY = GameVars.scaleY;
        this.add(scaledItemsContainer);

        const infoBox = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_3", "info_box");
        scaledItemsContainer.add(infoBox);

        const titleImg = new Phaser.GameObjects.Image(this.scene, 0, -240, "texture_atlas_3", "text_out_moves");
        scaledItemsContainer.add(titleImg);

        this.scene.tweens.add({
            targets: titleImg,
            scaleX: 1,
            scaleY: 1,
            ease: Phaser.Math.Easing.Back.Out,
            duration: 1000,
            delay: 1250
        });

        const scoreTitleLabel = new Phaser.GameObjects.Text(this.scene, 0, -50, "SCORE", {fontFamily: "Baloo", fontSize: "62px", align: "center", color: "#00C0FF"});
        scoreTitleLabel.setOrigin(.5);
        scaledItemsContainer.add(scoreTitleLabel);

        const scoreLabel = new Phaser.GameObjects.BitmapText(this.scene, 0, 40, "baloo", GameVars.formatNumber(GameVars.score), 80);
        scoreLabel.letterSpacing = 10;
        scoreLabel.x -= scoreLabel.width / 2 * 1.19;
        scoreLabel.setOrigin(0, .5);
        scaledItemsContainer.add(scoreLabel);

        const resetButton = new Button(this.scene, 0, 180, "texture_atlas_4", "btn_replay_off", "btn_replay_on");
        resetButton.onDown(this.onClickReset, this);
        scaledItemsContainer.add(resetButton);

        const bestScoreCapsule = new Phaser.GameObjects.Image(this.scene, 0, 350, "texture_atlas_5", "hud_best");
        scaledItemsContainer.add(bestScoreCapsule);

        const highScoreLabel = new Phaser.GameObjects.BitmapText(this.scene, 40, 356, "baloo", GameVars.formatNumber(GameVars.gameData.highScore), 42);
        highScoreLabel.letterSpacing = 5;
        highScoreLabel.x -= highScoreLabel.width / 2 * 1.19;
        highScoreLabel.setOrigin(0, .5);
        scaledItemsContainer.add(highScoreLabel);

        this.alpha = 0;

        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 350,
            delay: 750
        });
    }

    private onClickReset(): void {

        AudioManager.playSound("btn_click");
        GameManager.resetGame();
    }
}
